import React, { useEffect, useState } from 'react';
import { useFetch } from 'use-http';
import Dialog from 'src/components/common/Dialog.redesign';
import FormToggle from 'src/components/controls/forms/redesign/FormToggle';
import Button from 'src/components/controls/forms/redesign/FormButton';
import Form from 'src/components/controls/forms/Form';
import FormTextBox from 'src/components/controls/forms/redesign/FormTextbox';
// import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import { AnyObject } from 'final-form';
import { Url } from 'src/api';
import { useSelector } from 'react-redux';
import { IRootState } from 'src/reducers';
import EasternMap from 'src/models/EasternMap';
import { EasternMapType } from 'src/models/EasternMapType';
import TagContainer from 'src/components/counties/TagContainer';
import County from 'src/models/County';
import { SelectItem } from 'src/models/common/SelectItem';

interface IEasterMapDialogProps {
    onCloseDialog?: () => void;
    townshipId: number;
    mapNumber: number;
    action: 'create' | 'edit' | 'delete';
    onUpdateComplete: (easternMapNumber: number) => void;
}

const EasternMapDialog: React.FC<IEasterMapDialogProps> = (props) => {
    const [loadComplete, setLoadComplete] = useState<boolean>(false);
    const [easternMap, setEasternMap] = useState<EasternMap>(undefined);
    const [counties, setCounties] = useState([]);
    const [formApi, setFormApi] = useState(null);
    const { get, post, put, response } = useFetch();
    const appContext = useSelector((state: IRootState) => state.appContext);

    const loadData = async () => {
        if (props.action === 'edit') {
            const map = await get(Url.project.getEasternMap(appContext, props.mapNumber));
            if (response.ok) {
                setEasternMap(EasternMap.From(map));
            }
        }

        const result = await get(Url.project.getEasternTownshipCounties(appContext, props.townshipId));

        if (response.ok) {
            setCounties(result.items);
            setLoadComplete(true);
        }
    };

    useEffect(() => {
        loadData();
    }, [props.mapNumber]);

    const onValidate = (values: AnyObject) => {
        const errors: AnyObject = {};

        if (!values.mapType) {
            errors.mapType = 'Map Type Required';
        }

        if (!values.name) {
            errors.name = 'Name Required';
        }

        return errors;
    };

    const onSubmit = async (values: AnyObject) => {
        switch (values.mapTypeId) {
            case 'Map':
                values.mapTypeId = 1;
                break;
            case 'Plate':
                values.mapTypeId = 2;
                break;
            default:
                values.mapTypeId = 3;
                break;
        }

        if (props.action === 'create') {
            await post(`${Url.project.getEasternTownship(appContext, props.townshipId)}/maps`, values);

            if (response.ok) {
                props.onUpdateComplete(props.mapNumber);
                props.onCloseDialog();
            }
        }

        if (props.action === 'edit') {
            if (!easternMap.counties) {
                easternMap.counties = [];
            }

            if (!values.counties) {
                values.counties = [];
            }

            if (values.addCounties) {
                values.addCounties.forEach((c: County) => {
                    if (easternMap.counties.filter((mc: County) => c.id === mc.id).length <= 0) {
                        values.counties.push(c);
                    }
                });
                values.addCounties = [];
            }

            if (values.deleteCounties) {
                values.deleteCounties.forEach((c: County) => {
                    easternMap.counties = easternMap.counties.filter((mc: County) => c.id !== mc.id);
                });
                values.deleteCounties = [];
            }

            await put(`${Url.project.getEasternMap(appContext, props.mapNumber)}`, values);

            if (response.ok) {
                props.onUpdateComplete(props.mapNumber);
                props.onCloseDialog();
            }
        }
    };

    const createInitialValues = () => {
        if (easternMap) {
            return {
                name: easternMap.name,
                mapType: EasternMapType[easternMap.mapTypeId],
                counties: easternMap.counties,
                addCounties: [] as County[],
                deleteCounties: [] as County[],
            };
        }

        return undefined;
    };

    const actionText = `${props.mapNumber ? 'Update' : 'Create'} Map`;

    if (!loadComplete) {
        return <></>;
    } else {
        return (
            <Dialog title={actionText}>
                <Form
                    onSubmit={onSubmit}
                    validate={onValidate}
                    initialValues={createInitialValues()}
                    onFormCreated={!formApi && setFormApi}
                    hasFieldArray={true}
                >
                    <b>Map Type</b>
                    <FormToggle name="mapType" items={['Map', 'Plate', 'None']} />
                    <FormTextBox label="Name" name="name" />
                    <TagContainer
                        label="Counties"
                        fieldArrayName="counties"
                        fieldAddArrayName="addCounties"
                        fieldDeleteArrayName="deleteCounties"
                        initialValueName="county"
                        isTagCreatable={false}
                        form={formApi}
                        selectTags={counties.length > 0 ? counties.map((c: County) => new SelectItem(c.id, c.name)) : new Array<SelectItem>()}
                    />
                    <Button type="submit" text={actionText} />
                </Form>
            </Dialog>
        );
    }
};

export default EasternMapDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/dialogs/EasternMapDialog.tsx